import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { Footer } from "./shared/Footer";
import { Messages } from "./shared/Messages";

/**
 * @typedef {{
 *   id: number | string;
 *   type: "to-me" | "from-me";
 *   message: string;
 *   date: string;
 *   time: string;
 *   userImageUrl: string;
 *   userName: string;
 * }} Message
 * @param {{
 *   messages: Message[];
 *   onSend: (message: string) => Promise<void>;
 *   isLoading?: boolean;
 *   isSending?: boolean;
 *   messageCharLimit?: number;
 *   cannotSendReason?: string;
 *   renderTextarea?: (props: {
 *      value: string;
 *      onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
 *      placeholder: string;
 *      maxLength?: number;
 *      maxRows?: number;
 *      className?: string;
 *      isDisabled?: boolean;
 *   }) => React.ReactNode;
 *   footerAdornment?: React.ReactNode;
 * }} props
 */
export const Chat = ({
  messages,
  onSend,
  isLoading,
  isSending,
  messageCharLimit,
  cannotSendReason,
  className,
  renderTextarea,
  footerAdornment,
}) => {
  return (
    <div className={cx(styles.root, className)}>
      <Messages data={messages} isLoading={isLoading} />
      <Footer
        cannotSendReason={cannotSendReason}
        messageCharLimit={messageCharLimit}
        isLoading={isLoading}
        isSending={isSending}
        onSend={onSend}
        renderTextarea={renderTextarea}
        footerAdornment={footerAdornment}
      />
    </div>
  );
};
